export class DataCheck {
    id: string = "";
    nombre: string = "";
    seleccionado: boolean = false;
}
